
import './App.css';
import { Routes, Route } from "react-router-dom";
import Apply from './Components/Apply/Apply';
import ThankYou from './Components/ThankYou/ThankYou';
import AdminSubmissions from './Components/AdminSubmissions/AdminSubmissions';

function App() {
  return (
    <div className="App">

    <Routes>
          <Route path="/" element={<Apply/>} />
          <Route path="/thank-you" element={<ThankYou/>} />
          <Route path="/admission" element={<AdminSubmissions/>} />


  </Routes>
    </div>
  );
}

export default App;
